import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';
import { keyframes } from '@mui/system';

// Keyframes definitions
// const fadeIn = keyframes`
//   0% {
//     opacity: 0;
//     filter: blur(10px);
//   }
//   100% {
//     opacity: 1;
//     filter: blur(0);
//     transform: translateX(0);
//   }
// `;

const cloudyFadeOutLeft = keyframes`
  0% {
    opacity: 1;
    filter: blur(0);
    transform: translateX(0);
  }
  100% {
    opacity: 0;
    filter: blur(10px);
  }
`;

// Styled components
export const Container = styled(Box)<{ $fadeOut?: boolean; $fadeIn?: boolean }>(({ $fadeOut, $fadeIn }) => ({
  width: '100%',
  position: 'relative',
  height: 'var(--app-height)',
  minHeight: '550px',
  ...($fadeOut && {
    animation: `${cloudyFadeOutLeft} 1s ease-out forwards`,
    opacity: 1,
    pointerEvents: 'none',
  }),
  ...($fadeIn && {
    opacity: 1,
    pointerEvents: 'none',
  }),
}));

export const NavPanel = styled(Box)({
  position: 'absolute',
  width: '100%',
  bottom: '0',
  transform: 'translateX(-50%)',
  left: '50%',
  zIndex: 2,
});

export const ScreenWrapper = styled(Box)<{ $background: string }>(({ $background }) => ({
  width: '100%',
  height: '100%',
  background: $background || 'white',
  backgroundSize: '100% 100%',
}));

export const LaunchScreenWrapper = styled(Box)({
  width: '100%',
  height: 'var(--app-height)',
  overflow: 'hidden',
  position: 'relative',
});
